"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Date = exports._Date = void 0;
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var check_focus_1 = require("../../../utils/check-focus");
/**
 * @deprecated in favour for DateMui
 * @date 2022-09-21 - 3:43:15 p.m.
 */
exports._Date = (0, react_1.forwardRef)(function (_a, ref) {
    var hasError = _a.hasError, props = __rest(_a, ["hasError"]);
    var isFocused = (0, check_focus_1.checkFocus)(props, ref);
    return (react_1.default.createElement("input", __assign({ ref: ref }, (0, lodash_1.omit)(props, ["isFocused", "error"]), { value: props.value, style: !isFocused ? { color: "transparent" } : {}, className: (0, classnames_1.default)(props.className, getClasses({ isFocused: isFocused, hasError: Boolean(hasError) })), type: "date" })));
});
var base = "notranslate fs14 w-full border-0 rounded-md block outline-none";
var baseNoError = "bg-white";
var notFocused = "p-3";
var focus = "pl-3 pb-2 pr-3";
var error = "text-red-800";
var getClasses = function (_a) {
    var _b;
    var isFocused = _a.isFocused, hasError = _a.hasError;
    return (0, classnames_1.default)(base, (_b = {},
        _b[baseNoError] = !hasError,
        _b[error] = hasError,
        _b[focus] = isFocused,
        _b[notFocused] = !isFocused,
        _b));
};
var changeAdapter = function (e) {
    return e.target.valueAsDate;
};
/**
 * @deprecated in favour for DateMui
 * @date 2022-09-21 - 3:43:15 p.m.
 */
exports.Date = Object.assign(exports._Date, {
    css: {
        base: base,
        notFocused: notFocused,
        focus: focus,
    },
    changeAdapter: changeAdapter,
    displayName: "VistoDate",
});
